import { nostojs } from "@nosto/nosto-js"

/**
 * Reports a click to Nosto.
 *
 * @deprecated Use `window.nostojs` instead.
 */
export function reportClick(type: "serp" | "autocomplete" | "category", hit: { productId: string; url?: string }) {
    nostojs(api => api.recordSearchClick(type, hit))
}
